function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3714",
  "data-name": "Grupo 3714",
  transform: "translate(3487.635 -466.65)"
}, /*#__PURE__*/React.createElement("g", {
  id: "scZsch",
  transform: "translate(-3482.934 478.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3713",
  "data-name": "Grupo 3713",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_901",
  "data-name": "Caminho 901",
  d: "M-3405.723,648.528h-6.379a2.788,2.788,0,0,1-.347-.009.951.951,0,0,1-.834-.954.951.951,0,0,1,.837-.921,2.831,2.831,0,0,1,.347-.009h12.79c.095,0,.19,0,.284,0a.948.948,0,0,1,.9.96.942.942,0,0,1-.9.924c-.262.016-.526.006-.789.006Z",
  transform: "translate(3413.287 -646.633)",
  fill: "#fc9d73"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_902",
  "data-name": "Caminho 902",
  d: "M-3407.646,706.5c1.558,0,6.864-.005,8.422,0a.942.942,0,0,1,.919,1.32.946.946,0,0,1-.937.572c-1.021,0-5.79,0-6.811,0-2.084,0-4.168,0-6.253,0a.95.95,0,0,1-.964-1.293.97.97,0,0,1,.982-.6Q-3409.968,706.5-3407.646,706.5Z",
  transform: "translate(3413.342 -702.711)",
  fill: "#fc9d73"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_903",
  "data-name": "Caminho 903",
  d: "M-3407.652,766.388c1.558,0,6.864,0,8.422,0a.944.944,0,0,1,.933,1.311.924.924,0,0,1-.9.579c-.611,0-1.221,0-1.832,0-2.506,0-8.759,0-11.264,0a.952.952,0,0,1-.978-1.283.965.965,0,0,1,.975-.609Q-3409.973,766.385-3407.652,766.388Z",
  transform: "translate(3413.337 -758.809)",
  fill: "#fc9d73"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_904",
  "data-name": "Caminho 904",
  d: "M-3407.62,826.271c1.547,0,6.843,0,8.39,0a.944.944,0,0,1,.933,1.311.924.924,0,0,1-.9.579c-.61.005-1.221,0-1.832,0-2.505,0-8.759,0-11.264,0a.952.952,0,0,1-.978-1.283.965.965,0,0,1,.975-.609Q-3409.957,826.268-3407.62,826.271Z",
  transform: "translate(3413.337 -814.904)",
  fill: "#fc9d73"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_905",
  "data-name": "Caminho 905",
  d: "M-3464,469.991c-.906-.878-1.79-1.781-2.7-2.653a2.626,2.626,0,0,0-1.882-.684q-8.066-.007-16.132,0a2.814,2.814,0,0,0-2.878,2.441.306.306,0,0,1-.043.081v27.28a3.462,3.462,0,0,0,.631,1.45,2.809,2.809,0,0,0,1.781,1.03.54.54,0,0,1,.114.046h19.58a7.389,7.389,0,0,0,1.345-.568,2.6,2.6,0,0,0,1.149-1.9V471.848A3.139,3.139,0,0,0-3464,469.991Zm-4.665-1.433a.991.991,0,0,1,.864.323q1.284,1.279,2.565,2.561a1.017,1.017,0,0,1,.328.87h-3.757Zm3.767,27.427a.974.974,0,0,1-1.107,1.1h-18.633a.974.974,0,0,1-1.1-1.107q0-13.166,0-26.333a.969.969,0,0,1,1.076-1.1q6.9,0,13.8,0h.281v.362q0,2.1,0,4.2a.981.981,0,0,0,1.12,1.121c1.5,0,3.01,0,4.564,0v.343c0,2.231-.033,15.905-.033,15.905S-3464.9,494.139-3464.9,495.985Z",
  fill: "#fc9d73"
}));

var SvgListDash = function SvgListDash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.6,
    height: 32.334,
    viewBox: "0 0 24.6 32.334",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListDash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ListDash.29006afe.svg";
export { ForwardRef as ReactComponent };